import type { ViewDataWithSection } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { distributeProducts } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/shelf/common/distributeProducts';

export const addRestOfProducts =
  (shouldAddHeader?: boolean) =>
  async (viewData: ViewDataWithSection): Promise<ViewDataWithSection> => {
    const productsInFirstRow = shouldAddHeader
      ? viewData.layoutTable!.length - 2
      : 0;

    const products = viewData.section.products.slice(productsInFirstRow);

    const distributed = distributeProducts(viewData.section)({
      products,
      viewData,
      layout: viewData.layout,
      numOfColumns: viewData.layoutTable!.length,
    });
    let height = 0;
    distributed[0]?.forEach((item) => (height += item.size.height));

    viewData.layoutTable!.forEach((column) =>
      column.push(...distributed.shift()!)
    );
    return viewData;
  };
